import React from "react";
import ReactDOM from 'react-dom';
import './index.css';
import Login from "./components/login";
import Preview from "./pages/preview";
import { BannerDimensionsContext } from './contexts/BannerDimensionsContext'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { AuthContext } from './contexts/auth.js'


ReactDOM.render(
  <React.StrictMode>
    <AuthContext>
      <BannerDimensionsContext>
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/preview/:item" component={Preview} />
          </Switch>
        </BrowserRouter>
      </BannerDimensionsContext>
    </AuthContext>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
